<div class="statusComponent__container" [style.backgroundColor]="color">
  <div class="statusComponent__content">
    <img class="statusComponent__icon" [src]="caminho" alt="">
    <span class="statusComponent__text">{{mensagem}}</span>
  </div>
</div>